import { DistributedPick, ReadonlyDeep } from 'type-fest'
import { Affiliations, Marker } from '../chat-data/types'
import { PayloadIn } from '../xmpp-client/types'

export const getLastEventWithPreview = <
  TEvent extends ReadonlyDeep<
    DistributedPick<PayloadIn | Marker | Affiliations, 'type' | 'parts' | 'payload' | 'action'>
  >,
>(
  lastEvents: ReadonlyDeep<Array<TEvent>>
) => {
  const hasLiveMessage = lastEvents.some(event => event.type === 'LiveMessage')
  for (const event of lastEvents) {
    if (
      // LiveMessage with Text part is previewable
      (event.type === 'LiveMessage' && event.parts[0]?.type === 'Text') ||
      // SuggestedTimes is previewable
      event.type === 'SuggestedTimes' ||
      // Specific SystemMessages are previewable
      (event.type === 'SystemMessage' &&
        event.payload.type !== 'MeetingSchedulingRequested' &&
        event.payload.type !== 'MeetingSchedulingFailed' &&
        // Only show assignment if there's a live message (avoid on initial load)
        (hasLiveMessage || event.payload.type !== 'SystemConversationAssigned') &&
        (event.payload.type === 'SystemConversationAssigned' ||
          event.payload.type === 'SystemConversationReassigned' ||
          event.payload.type === 'SystemRepsHaveFailedToRespond')) ||
      // ConversationData with RepJoinOrTimeoutAction is previewable
      (event.type === 'ConversationData' && event.action.type === 'RepJoinOrTimeoutAction') ||
      // ConversationSessionExpired is previewable
      (event.type === 'SystemMessage' && event.payload.type === 'ConversationSessionExpired') ||
      // StatusChange is previewable
      event.type === 'StatusChange'
    ) {
      return event
    }
  }
}
